<app-banners secaoUrl="atendimento"></app-banners>
  <div class="text-center">
    <router-outlet></router-outlet>
  </div>
